import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import autoLoginEmailUserEAuth from "../services/autoLoginEmailUserEAuth";
import CircularProgress from "@mui/material/CircularProgress";
import { styled, Box } from "@mui/material";
import ButtonCustom from "../components/buttons/Button";
import LogoErrepar from "../assets/svg/logo-errepar";
import InputData from "../components/InputData";
import TextInput from "../components/text/TextInput";
import ErrorIcon from "../assets/svg/error-icon";
import Title from "../components/text/Title";
import Subtitle from "../components/text/Subtitle";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../theme/theme';


export default () => {
  const { user } = useParams();
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(true);
  const [validLogin, setValidLogin] = useState(false);
  const [ errorInput, setErrorInput] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const media = useMediaQuery(theme.breakpoints.down('md'));


  const ContainerForm = {
    width: "100%",
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    flexDirection: "column",
    gap: "2rem",
    marginBottom: "5rem",
    overflow: "hidden"
  };

  const BoxLogo = styled(Box)(({ theme }) => ({
    width: "19rem",
    marginBottom: "2rem",
    [theme.breakpoints.down("md")]: {
      width: "10rem",
      marginBottom: "1rem",
    },
  }));

  const isEmail = () => {
    const validArroba = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!validArroba.test(email)) return false;

    if (email.match(/^[0-9]+$/) != null) return false;
    return true;
  };

  const onSent = () => {
    setErrorInput(false)
    if (isEmail(email)) return window.location.replace(`/autologin/email/${email}`);
    setErrorInput(true);
  };

  const onBack = () => {
    window.location.replace(`/autologin/email`);
  }

  useEffect(() => {

    if (user)
      autoLoginEmailUserEAuth(user, (state) => {
        console.log(state);
        if (state.status == "INVALID") setErrorMessage("Dominio de email inválido");
        if (state.status == "ERROR") setErrorMessage("Ocurrio un error interno. Por favor intente más tarde");

        setLoader(false);
        if (state?.code === 200) {
          setValidLogin(true);
          setTimeout(() => window.location.replace('about:blank'), 30000);
      }
      });

    if (!user) setLoader(false);
 
    
  }, []);

  const handleKeyPress = (event) => {
    setErrorInput(false);
    if (event.key === "Enter") onSent();
  };

  return (
    <div>
      {loader && (
        <Box sx={ContainerForm}>
          <CircularProgress size={"5rem"} sx={{ color: "#263057" }} />
        </Box>
      )}
      {!loader && (
        <>
          {validLogin && (
            <Box sx={ContainerForm}>
              <Box sx={{marginRight:media ? "2rem" : "5rem", marginLeft: media ? "2rem" : "0rem"}} > 
              <Box sx={{ width:"50%", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                <Box sx={{width:"15rem", marginLeft: media ? '3rem' : '0rem',marginTop:"-2rem", marginBottom:"3rem"}}>
                <LogoErrepar />
                </Box>
              </Box>
              <Box sx={{ display:'flex', alignItems:"center"}} >
               <CheckCircleIcon fontSize="large" color="success" sx={{marginBottom: "2rem"}} ></CheckCircleIcon>
                <Box sx={{ marginInline: "-2rem", marginBottom: "-1.3rem",}}>
                <Title>Las credenciales de acceso a errepar.com fueron enviadas al email {<u>{user}</u>}</Title>
                <Subtitle>Revise su casilla de correo. Sí no ves ningún correo revisá la carpeta de spam.</Subtitle>
               </Box>
              </Box>
   
                </Box>           
            </Box>
          )}
          {!validLogin && user && (
            <Box sx={ContainerForm}>
              
             <Box sx={{ display:'flex', alignItems:"center" , paddingLeft: media ? "3rem" : '0rem'}} > 
               <ErrorIcon  />
               <Box sx={{ marginInline: "-2rem", marginBottom: "-1.3rem",}}>
               <Title>{errorMessage}</Title>
               </Box>
              </Box>
               <ButtonCustom
                borderRadius={16}
                width={ media ? '50%' : '10%'}
                variant={'contained'}
                color={'white'}
                background={'#263057'}
                onClick={onBack}
                size="medium"
                label={'VOLVER A INTENTAR'}
          
              ></ButtonCustom>
            </Box>
          )}
          {!user && (
            <Box sx={ContainerForm}>
              <BoxLogo>
                <LogoErrepar />
              </BoxLogo>
              <Box sx={{width: media ? "50%" : "25%" }} >
                <TextInput color={"#263057"} fontWeight={"bold"} fontSize={14}>
                Ingrese su correo electrónico institucional de la Universidad Austral
                </TextInput>

                <InputData
                  onKeyPress={handleKeyPress}
                  onChange={setEmail}
                  autoFocus
                  label={"Email"}
                  placeHolder={"nombre.apellido@email.com"}
                ></InputData>
                 {errorInput &&  <TextInput color={'#AD0707'} fontSize={12}>
                  Ingrese un email válido
                </TextInput>}
              </Box>
              <ButtonCustom
                borderRadius={16}
                width={media ? '50%' : "10%"}
                variant={"contained"}
                color={"white"}
                background={"#263057"}
                onClick={onSent}
                size="medium"
                label={"INGRESAR"}
              ></ButtonCustom>
            </Box>
          )}
        </>
      )}
    </div>
  );
};
